import React from 'react';
import LandlordToolkitLayout from '../../components/landlord-toolkit/LandlordToolkitLayout';
import ComplianceDashboard from '../../components/landlord-dashboard/ComplianceDashboard';

const CompliancePage: React.FC = () => {
  return (
    <LandlordToolkitLayout title="Compliance Overview">
      <ComplianceDashboard />
    </LandlordToolkitLayout>
  );
};

export default CompliancePage;
